import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import AuditLog from '../../entities/admin/auditlog'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface AuditLogState extends ListState<AuditLog>{
    editModel: AuditLog;
    activeList: Array<AuditLog>;
}
class AuditLogModule extends ListModule<AuditLogState, any, AuditLog>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<AuditLog>(),
        loading:false,
        editModel:new AuditLog(),
        activeList: new Array<AuditLog>(),
        path: 'audit-logs'
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
    });
}
const auditlogModule=new AuditLogModule();
export default auditlogModule;